'use client';

import { Button } from '@common/components';
import { SvgShare2 } from '@common/icon';

import { useGlobalStore } from '@/stores/GlobalStore';

export const ShareButton = () => {
  const setShareLink = useGlobalStore((state) => state.setShareLink);

  return (
    <Button
      aria-label="공유하기"
      className="size-fit p-0"
      theme="sub-text"
      onClick={() => {
        setShareLink(location.href);
      }}
    >
      <SvgShare2 className="size-20 text-Gray-600" />
    </Button>
  );
};
